import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

// Connects to data-controller="slim-select"
export default class extends Controller {
  static targets = ["select"];

  static values = { itemId: String, orderId: String, mode: String };

  declare selectTarget: HTMLSelectElement;
  declare hasSelectTarget: boolean;
  declare itemIdValue: string;
  declare hasItemIdValue: boolean;
  declare orderIdValue: string;
  declare hasOrderIdValue: boolean;
  declare modeValue: string;
  declare hasModeValue: boolean;

  connect() {
    if (this.hasSelectTarget) {
      let select = new SlimSelect({
        select: this.selectTarget,
        settings: {
          searchPlaceholder: "Rechercher",
          searchText: "Aucun résultat",
        },
        events: {
          afterChange: () => {
            if (this.hasItemIdValue || this.hasOrderIdValue) {
              const urlWithoutParams = window.location.toString().split("?")[0];
              if (this.hasModeValue && this.modeValue == "team") {
                if (this.hasItemIdValue) {
                  document.location.href = `${urlWithoutParams}?item_id=${this.itemIdValue}&team_id=${
                    select.getSelected()[0]
                  }`;
                } else if (this.hasOrderIdValue) {
                  document.location.href = `${urlWithoutParams}?order_id=${this.orderIdValue}&team_id=${
                    select.getSelected()[0]
                  }`;
                }
              } else {
                if (this.hasItemIdValue) {
                  document.location.href = `${urlWithoutParams}?item_id=${this.itemIdValue}&type=individual&user_id=${
                    select.getSelected()[0]
                  }`;
                } else if (this.hasOrderIdValue) {
                  document.location.href = `${urlWithoutParams}?order_id=${this.orderIdValue}&type=individual&user_id=${
                    select.getSelected()[0]
                  }`;
                }
              }
            }
          },
        },
      });
    }
  }
}
